import { render, staticRenderFns } from "./ExportClassificationsForReach.vue?vue&type=template&id=0363d518"
import script from "./ExportClassificationsForReach.vue?vue&type=script&lang=js"
export * from "./ExportClassificationsForReach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports